<template lang="pug">
  .clinical-portal-view
    .loading-dots
      .dot1
      .dot2
      .dot3
    p {{errorMessage}}
</template>

<script>
import clinicalPortalSvc from '@/services/clinicalPortalSvc.js';
import auth from '@/services/authSvc.js';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      retries: 0,
      maxRetries: 5,
      clinicalPortalToken: '',
      errorMessage: ''
    };
  },
  methods: {
    ...mapActions(['authChanged', 'loadApiConfig']),
    ...mapMutations(['setClinicalPortalToken']),
    listenerFactory(self) {
      const redirectToPatientView = () => {
        const patientId = auth.getTokenIdentity();

        if (!patientId) {
          return;
        }

        window.removeEventListener('message', self.messageListener);

        self.$router.push({ name: 'Patient', params: { id: patientId } });
      };

      return message => {
        // We already have a clinical portal token
        if (auth.isLoggedIn() && auth.isClinicalPortal()) {
          this.loadApiConfig();
          redirectToPatientView();
          return;
        }

        // Wait for clinical portal to send the auth token
        if (!message.data.clinicalPortalToken) {
          return;
        }

        // Don't thrash or spam the API if there are auth errors
        if (self.retries >= self.maxRetries) {
          self.errorMessage = `Could not login, tried: ${this.maxRetries}, stopping for now`;
          console.log(self.errorMessage);
          return;
        }

        self.clinicalPortalToken = message.data.clinicalPortalToken;
        this.setClinicalPortalToken(message.data.clinicalPortalToken);

        clinicalPortalSvc
          .loginUserWithClinicalPortalToken({
            authToken: message.data.clinicalPortalToken,
            reauthToken: message.data.clinicalPortalToken
          })
          .then(
            response => {
              if (response && response.status === 200) {
                const sessionToken = response.headers['x-session-token'];
                auth.setToken(sessionToken, true);
                this.authChanged();
                this.loadApiConfig();
                redirectToPatientView();
              }
            },
            () => {
              self.retries++;
            }
          );
      };
    },
    messageListener() {}
  },
  mounted() {
    this.$nextTick(function() {
      const self = this;
      self.messageListener = self.listenerFactory(self);

      window.addEventListener('message', self.messageListener);
    });
  },
  beforeUnmount() {
    window.removeEventListener('message', this.messageListener);
  }
};
</script>

<style lang="scss" scoped></style>
